export default "__VITE_ASSET__C6$0dXiz__"